import React, { Component, PropTypes } from 'react'

import { getFlatterenedFieldErrors } from 'utils/errors'
import ErrorMessageUser from './error-message-user'


export class ErrorMessageUserContainer extends Component {

  render() {
    const { error } = this.props
    const flatternedFieldErrors = getFlatterenedFieldErrors(error)

    return (
      <ErrorMessageUser error={error} flatternedFieldErrors={flatternedFieldErrors} />
    )
  }
}

ErrorMessageUserContainer.propTypes = {
  error: PropTypes.object,
}

export default ErrorMessageUserContainer



/** WEBPACK FOOTER **
 ** ./src/components/error-message/error-message-user/error-message-user-container.js
 **/